import { AIForMeTool } from "lib/models/aiforme-models";
import { CatalogicalService, UserPermissions } from "lib/services";
import { useEffect, useState } from "react";

type SortOption = {
  field: string;
  order: "asc" | "desc";
};

const sortingOption: SortOption = { field: "creationDate", order: "desc" };

export const useMyAiToolsTable = (client: CatalogicalService<AIForMeTool>) => {
  const username = UserPermissions.current.username;
  const [loading, setLoading] = useState<boolean>(true);
  const [aiTools, setAiTools] = useState<AIForMeTool[]>([]);

  useEffect(() => {
    GetItems().then((response) => {
      if (response) {
        setAiTools(response.data || []);
      }
    });
  }, []);

  const GetItems = async () => {
    setLoading(true);
    try {
      const response = await client.getItems({
        sortBy: [sortingOption.field],
        sortDirection: [sortingOption.order],
        filters: { username },
      });
      setLoading(false);

      return response;
    } catch (err) {
      setLoading(false);
    }
  };

  return { aiTools, loading };
};
